export const createIframe = (src: string, name: string) => {
  const $iframe = document.createElement("iframe");
  $iframe.src = src;
  $iframe.name = name;
  $iframe.id = `tango_id_${name}`;

  return $iframe;
};
